/**
 * API origin with no trailing slash. Prevents `https://host.com//api/...` when
 * REACT_APP_API_BASE_URL ends with `/`, which breaks API Gateway routes and CORS preflight.
 */
export function getApiBase() {
  const raw = process.env.REACT_APP_API_BASE_URL;
  if (raw !== undefined && raw !== null && String(raw).trim() !== "") {
    return String(raw).trim().replace(/\/+$/, "");
  }
  if (process.env.NODE_ENV === "development") {
    return "http://localhost:4000";
  }
  return "";
}
